import { useEffect, useState } from 'react';
import { ecouterEtatSynchro, traiterFile, type EtatSynchro } from '../offline/syncQueue.ts';
import { surChangement, lireEtatModules, listerIncidents } from '../offline/dbModules.ts';

/** Badge unique : consultations RCE + modules (PEV, intrants, finance, décès, communication, inventaires). */
export default function SyncBadge({ onClick }: { onClick?: () => void }) {
  const [etat, setEtat] = useState<EtatSynchro>('IDLE');
  const [nbRce, setNbRce] = useState(0);
  const [mod, setMod] = useState(lireEtatModules());
  const [incidents, setIncidents] = useState(0);
  const [enLigne, setEnLigne] = useState(navigator.onLine);

  useEffect(() => ecouterEtatSynchro((e, nb) => { setEtat(e); setNbRce(nb); }), []);
  useEffect(() => {
    const maj = () => { setMod(lireEtatModules()); void listerIncidents().then((l) => setIncidents(l.filter((i) => !i.vu).length)); };
    maj();
    return surChangement(maj);
  }, []);
  useEffect(() => {
    const on = () => setEnLigne(true), off = () => setEnLigne(false);
    window.addEventListener('online', on); window.addEventListener('offline', off);
    return () => { window.removeEventListener('online', on); window.removeEventListener('offline', off); };
  }, []);
  useEffect(() => { void traiterFile(); }, []); // tentative silencieuse au montage de l'app

  const attente = nbRce + mod.nbAttente;
  let contenu: string, classe: string;
  if (etat === 'SYNCING' || mod.etat === 'SYNCING') { contenu = '↻ Synchronisation…'; classe = 'pending'; }
  else if (incidents > 0) { contenu = `⚠ ${incidents} à vérifier`; classe = 'pending'; }
  else if (attente > 0) { contenu = `${enLigne ? '⚠' : '⊘'} ${attente} en attente`; classe = 'pending'; }
  else if (!enLigne) { contenu = '⊘ Hors connexion'; classe = 'offline'; }
  else { contenu = '✓ Synchronisé'; classe = 'synced'; }
  return <button className={`badge-sync ${classe}`} onClick={onClick} title="Voir l'état de la synchronisation">{contenu}</button>;
}
